/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
// Mantine
import {
	Box,
	LoadingOverlay,
	Text,
	Tooltip,
} from '@mantine/core';

// Styles
import classes from './Measurabilities.module.css';

// I18n
import { useTranslation } from 'react-i18next';

// Constants
import { NOT_APPLICABLE } from '@config/constants/common';

// Utils
import { truncateString } from '@utils/functions';

// Apis
import { useOffsetById } from '@features/offsets/api/get-offset-by-id';

// Lodash
import isNil from 'lodash/isNil';

// Types
import { ROLES } from '@config/constants/roles';
import { TParsedRowProject } from '@features/offsets/types';
import { useAuthorization } from '@lib/authorization';

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */
type RowExpansionProps = {
	offsetId: string;
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

export const Additionalities = (
	props: RowExpansionProps
) => {
	/* ******************************** Hooks ******************************* */
	const { t } = useTranslation();

	const { additionalities, isLoading } = useOffsetById(
		props.offsetId
	);
	const { checkRole } = useAuthorization();
	const rowsAdditionality =
		Array.isArray(additionalities) &&
		additionalities.length > 0 ? (
			additionalities.map((item: TParsedRowProject) => (
				<Box key={item.id} className={classes.row}>
					<Tooltip
						disabled={
							(!isNil(item) && isNil(item.name)) ||
							(!isNil(item.name) &&
								item.name.length <= 30)
						}
						label={item.name}
					>
						<Box className={classes.divition}>
							<Text className={classes.rowText}>
								{truncateString(item.name, 30)}
							</Text>
						</Box>
					</Tooltip>
					<Box className={classes.divition}>
						<Text className={classes.rowText}>{''}</Text>
					</Box>
					<Box className={classes.divition}>
						<Text className={classes.rowText}>{''}</Text>
					</Box>
					{!checkRole([ROLES.STAFF]) && (
						<Box className={classes.divition}>
							<Text className={classes.rowText}>
								{item.total}
							</Text>
						</Box>
					)}
				</Box>
			))
		) : (
			<Box className={classes.row}>
				<Box className={classes.divition}>
					<Text className={classes.rowText}>
						{NOT_APPLICABLE}
					</Text>
				</Box>
				<Box className={classes.divition}>
					<Text className={classes.rowText}></Text>
				</Box>
				<Box className={classes.divition}>
					<Text className={classes.rowText}></Text>
				</Box>
				{!checkRole([ROLES.STAFF]) && (
					<Box className={classes.divition}>
						<Text className={classes.rowText}>
							{NOT_APPLICABLE}
						</Text>
					</Box>
				)}
			</Box>
		);

	/* ******************************** RENDERING ******************************* */
	return (
		<>
			{isLoading ? (
				<Box
					pos="relative"
					className={classes.containerOverlay}
				>
					<LoadingOverlay
						visible={true}
						zIndex={1000}
						overlayProps={{ radius: 'sm', blur: 2 }}
					/>
				</Box>
			) : (
				<Box className={classes.container}>
					<Box className={classes.header}>
						<Box className={classes.divition}>
							<Text className={classes.headerText}>
								{t('global.project')}
							</Text>
						</Box>
						<Box className={classes.divition}>
							<Text className={classes.headerText}></Text>
						</Box>
						<Box className={classes.divition}>
							<Text className={classes.headerText}></Text>
						</Box>
						{!checkRole([ROLES.STAFF]) && (
							<Box className={classes.divition}>
								<Text className={classes.headerText}>
									{t('global.totalAdditionality')}
								</Text>
							</Box>
						)}
					</Box>

					<Box className={classes.row}>
						{/*Additional projects rows */}
						<Box className={classes.rowsDivision}>
							{rowsAdditionality}
						</Box>
					</Box>
				</Box>
			)}
		</>
	);
};
